export default {
  en: {
    ACTION_CREATE_WEBHOOK: 'Create Webhook',

    PLACEHOLDER_WEBHOOK_SEARCH: 'Search Webhooks',

    MESSAGE_UPDATE_SUCCESS: 'Webhook updated',
    MESSAGE_CREATE_SUCCESS: 'Webhook created',
    MESSAGE_DELETE_SUCCESS: 'Webhook deleted successfully',

    //Table
    TABLE_HEADER_COL_WEBHOOK: 'Webhook',
    TABLE_HEADER_COL_REPORTING_MENU_NAME: 'Reporting Menu Name',
    TABLE_HEADER_COL_REPORT_NAME: 'Report Name',
    INPUT_LABEL_WEBHOOK: 'Webhook',
    INPUT_LABEL_WEBHOOK_TT: 'The webhook you\'d like Ringba to tag.',
    INPUT_LABEL_REPORTING_MENU_NAME: 'Reporting Menu Name',
    INPUT_LABEL_REPORTING_MENU_NAME_TT:
      'The Menu Option in Reporting under the Tags menu where you can find this data.',
    INPUT_LABEL_REPORT_NAME: 'Report Name',
    INPUT_LABEL_REPORT_NAME_TT:
      'The name of the report that will show up in your Menu Name.',
    TT_DELETE: 'Delete Webhook',

    WEBHOOKS_TABLE_LOADING: 'Loading Webhooks',
    WEBHOOKS_TABLE_EMPTY: 'You have not created any webhooks.',

    //Modal
    TITLE_DELETE: 'Delete Webhook',
    LABEL_DELETE_CONFIRMATION_MESSAGE:
      'Are you sure you want to delete {name}?',

    WEBHOOKS_CALL_ID: 'Call Token',

    WEBHOOK_ADD_SUCCESS: 'Webhook created successfully',
    WEBHOOK_CREATE_AND_ADD_SUCCESS: 'Webhook created and linked.',
    WEBHOOKS_CALL_ID_DEFAULT: 'call_id',
    WEBHOOKS_CALL_ID_TT:
      'The URL variable your system will pass back our Call ID with.',
    WEBHOOKS_CAMPAIGN_SPECIFIC_TT:
      'Only fire the campaign-specific pixels when triggered.',
    WEBHOOKS_CAMPAIGN_SPECIFIC: 'Campaign Specific',
    WEBHOOKS_CANCEL_BUTTON: 'Cancel',
    WEBHOOKS_CREATE_SUCCESS: 'Webhook created.',
    WEBHOOKS_CREATE_WEBHOOK: 'Create Webhook',
    WEBHOOKS_DELETE_SUCCESS: 'Webhook deleted.',
    WEBHOOKS_EXISTING_ACTIONS: 'Actions',
    WEBHOOKS_EXISTING_CALL_ID: 'Call Token',
    WEBHOOKS_EXISTING_CONVERSION_CHECK: 'Fire Pixels',
    WEBHOOKS_EXISTING_DELETE_TT: 'Delete',
    WEBHOOKS_EXISTING_EDIT_TT: 'Edit',
    WEBHOOKS_EXISTING_ENABLED: 'Enabled',
    WEBHOOKS_EXISTING_ENDPOINT_CALL_IT: '[Call_ID]',
    WEBHOOKS_EXISTING_ENDPOINT_REVENUE_AMOUNT: '[Revenue]',
    WEBHOOKS_EXISTING_ENDPOINT_URL: 'Endpoint',
    WEBHOOKS_EXISTING_REVENUE: 'Revenue Token',
    WEBHOOKS_FIRE_PIXEL_DEFAULT: 'sale_successful=yes',
    WEBHOOKS_FIRE_PIXEL_TT: 'Enter the URL variable you want the system to require to record the conversion. If the buyer has a Ringba account, this field is required.',
    WEBHOOKS_FIRE_PIXEL: 'Fire Conversion',
    WEBHOOKS_HEADER_NONE: 'You have not created any webhooks.',
    WEBHOOKS_HEADER_TT:
      'Add a webhook to pass data into any of your compaigns for more accurate tracking.',
    WEBHOOKS_HEADER: 'Webhooks',
    WEBHOOKS_LOADING: 'Loading Webhooks.',
    WEBHOOKS_NAME_DEFAULT: 'My Webhook',
    WEBHOOKS_NAME_TT:
      'Your webhook name will be used to display information about the webhook.',
    WEBHOOKS_NAME: 'Name',
    WEBHOOKS_PAGE_TITLE: 'Webhooks',
    WEBHOOKS_REVENUE_DEFAULT: 'call_revenue',
    WEBHOOKS_REVENUE_TT:
      'The URL Variable your system will pass back revenue with.',
    WEBHOOKS_REVENUE: 'Revenue Token',
    WEBHOOKS_SAVE_BUTTON: 'Create',
    WEBHOOKS_UPDATE_BUTTON: 'Update',
    WEBHOOKS_UPDATE_SUCCESS: 'Webhook updated.'
  }
};
